import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Building2 } from "lucide-react";
import { Link } from "@/lib/router-compat";

const CTASection = () => {
  const { t } = useTranslation('home');

  return (
    <section className="py-32 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16 animate-fade-in max-w-3xl mx-auto">
            <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4 font-medium">
              Get started
            </p>
            <h2 className="text-4xl md:text-5xl font-bold mb-5 text-balance">
              {t('cta.title')}
            </h2>
            <p className="text-lg text-muted-foreground text-balance">
              {t('cta.subtitle')}
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-5">
            <Card className="animate-fade-in" style={{ animationDelay: "120ms" }}>
              <CardContent className="p-8">
                <div className="w-11 h-11 rounded-xl bg-foreground/[0.04] border border-border/60 flex items-center justify-center mb-5">
                  <Building2 className="text-foreground" size={20} strokeWidth={1.75} aria-hidden="true" />
                </div>
                <h3 className="text-xl font-semibold mb-2 tracking-tight">{t('cta.exploreTitle')}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed mb-6">
                  {t('cta.exploreDescription')}
                </p>
                <Button variant="outline" className="w-full" asChild>
                  <Link to="/companies" aria-label="Browse top nearshore software companies in Africa">
                    {t('cta.exploreButton')}
                    <ArrowRight size={16} aria-hidden="true" />
                  </Link>
                </Button>
              </CardContent>
            </Card>

            <Card className="animate-fade-in" style={{ animationDelay: "240ms" }}>
              <CardContent className="p-8">
                <div className="w-11 h-11 rounded-xl bg-foreground border border-border/60 flex items-center justify-center mb-5">
                  <ArrowRight className="text-background" size={20} strokeWidth={2} aria-hidden="true" />
                </div>
                <h3 className="text-xl font-semibold mb-2 tracking-tight">{t('cta.journeyTitle')}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed mb-6">
                  {t('cta.journeyDescription')}
                </p>
                <Button className="w-full" asChild>
                  <a
                    href="https://www.evolvice.de/en"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Contact Evolvice GmbH to start your nearshore partnership (opens in new tab)"
                  >
                    {t('cta.journeyButton')}
                    <ArrowRight size={16} aria-hidden="true" />
                  </a>
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
